// extracted by mini-css-extract-plugin
export default {"root":"TabEvaluationList_root__KOGDs"};